import { CreditCardIcon, Icon, XStack } from 'smoothie';

import AmexLogo from '../../../assets/images/logos/amex-logo.svg';
import DiscoverLogo from '../../../assets/images/logos/discover-logo.svg';
import MastercardBadgeLogo from '../../../assets/images/logos/mastercard-badge-logo.svg';
import VisaLogo from '../../../assets/images/logos/visa-logo.svg';

const BADGE_SIZE = { width: 34, height: 22 };

const BRAND_LOGOS: Record<string, typeof VisaLogo> = {
    visa: VisaLogo,
    mastercard: MastercardBadgeLogo,
    amex: AmexLogo,
    'american express': AmexLogo,
    discover: DiscoverLogo,
};

interface CardBrandIconProps {
    brand: string;
}

const CardBrandIcon = ({ brand }: CardBrandIconProps) => {
    const Logo = BRAND_LOGOS[brand.toLowerCase()];

    if (Logo == null) {
        return (
            <XStack
                {...BADGE_SIZE}
                borderRadius={4}
                backgroundColor="$gray300"
                alignItems="center"
                justifyContent="center"
            >
                <Icon icon={CreditCardIcon} size={14} color="$gray1000" />
            </XStack>
        );
    }

    return <Logo {...BADGE_SIZE} />;
};

export default CardBrandIcon;
